//CSS
import '../../Components/Page/Page.css'
import './GoToMark.css';
import slide17 from '../../Images/Slides/90aSlide17.png'
import SlideComp from '../../Components/SlideComp/SlideComp';

//React
import React from 'react';
import SecHeader from '../../Components/SecHeader/SecHeader';


const GoToMark: React.FC = () => {
    return (
        <div id="Goals">
            <SecHeader title="Go To Market" />

            <SlideComp source={slide17} />
        </div>
    );
};

export default GoToMark;